import moment from 'moment';
import ApexCharts from 'apexcharts';
import React, { useEffect } from 'react';
const CreateMonthlySummaryChart = (af_detection_summary_data, type) => {
    const chartNodePlaceHolder = document.getElementsByClassName(type)[0];
    if (chartNodePlaceHolder.children.length)
        return; //avoid duplications
    const processArrays = af_detection_summary_data;
    const options = {
        series: [
            {
                name: 'AF Detection Time',
                data: processArrays === null || processArrays === void 0 ? void 0 : processArrays.af.map((e) => Number.parseFloat(e).toFixed(1))
            },
            {
                name: 'Non-AF Time',
                data: processArrays.non_af.map((e) => Number.parseFloat(e).toFixed(1)),
            },
            {
                name: 'Off-Wrist Time',
                data: processArrays.non_readable.map((e) => Number.parseFloat(e).toFixed(1)),
            },
        ],
        chart: {
            type: 'bar',
            height: 500,
            stacked: true,
            stackType: '100%',
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        responsive: [
            {
                breakpoint: 20,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0,
                    },
                },
            },
        ],
        colors: ['#e6543d', '#a6b145', '#717171'],
        xaxis: {
            categories: processArrays.dates.map((e) => {
                return moment(e).format('DD MMM').split(' ');
            }),
        },
        yaxis: {
            tickAmount: 5,
            min: 0,
            max: 100,
            labels: {
                formatter: (value) => {
                    return `${value}%`;
                },
            },
        },
        fill: {
            opacity: 1,
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
        },
    };
    const chart = new ApexCharts(chartNodePlaceHolder, options);
    chart.render();
};
export default function CreateChart({ af_detection_summary_data, type }) {
    useEffect(() => {
        af_detection_summary_data &&
            CreateMonthlySummaryChart(af_detection_summary_data, type);
    }, []);
    return (React.createElement("div", { className: type }));
}
